<template>
  <div>
    <v-text-field
      box
      label="Respuesta"
      :error-messages="textErrors"
      placeholder="Ingrese su respuesta"
      v-model="answer"
      @input="$emit('get_answer', { option: answer, question: question})"
      @blur="$v.answer.$touch()"
    ></v-text-field>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      answer: ""
    };
  },
  props: {
    question: {
      type: Object,
      required: true
    },
  },
  validations: {
    answer: {
      required,
      minLength: minLength(3)
    }
  },
  computed: {
    textErrors() {
      const errors = [];
      if (!this.$v.answer.$dirty) return errors;
      !this.$v.answer.minLength && errors.push("Mínimo 3 caracteres.");
      if (!this.question.optional) !this.$v.answer.required && errors.push("Este campo es requerido.");
      return errors;
    }
  }
};
</script>